import { createSlice } from '@reduxjs/toolkit';

// todo: need to remove once api is done
const reducerName = 'applicationFormSettings';
const initialState = {
  searchTerm: null,
  filters: {
    department_ids: [],
    office_ids: [],
    employment_type: [],
    // Flag-on twin of employment_type. Listed so `clearFilter` restores an
    // empty array rather than undefined.
    ats_work_type_ids: [],
    isFilterApplied: false,
  },
  page: {
    number: 0,
    offset: 0,
    limit: 20,
  },
  sort: {
    label: 'Created date (Oldest to newest)',
    value: 'asc',
    element: 'created_at',
    order: 'asc',
  },
};

const { reducer, actions: applicationFormSettingsActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    resetJobState: (state, { payload: { key } }) => {
      state[key] = { ...initialState[key] };
    },

    applySort: (state, { payload }) => {
      state.sort = payload;
    },

    applyFilter: (state, { payload }) => {
      const { key, value } = payload;
      state.filters[key] = value;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.page.number = page;
      state.page.offset = state?.page?.number * state?.page?.limit;
      state.searchTerm = '';
    },

    clearFilter: (state, { payload }) => {
      const { key } = payload;
      state.filters[key] = initialState.filters[key];
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = Object.values(state.filters).some(
        (filter) => filter !== initialState.filters[key]
      );
    },

    clearAllFilter: (state) => {
      state.filters = { ...initialState.filters };
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    clearData: (state) => {
      state.sort = { ...initialState.sort };
      state.currentView = initialState.currentView;
      state.searchTerm = '';
    },

    applySearch: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
      state.page = { ...initialState.page };
    },
  },
});

export { applicationFormSettingsActions };
export default reducer;
